import { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getNews } from '../features/news/newsSlice';
import Logo from '../assets/logo-literasiologi.svg';

const Header = () => {
  const websiteShortName = process.env.REACT_APP_WEBSITE_SHORT_NAME || 'Literasiologi Indonesia';
  const [isMegamenuOpen, setIsMegamenuOpen] = useState(false);
  const megamenuRef = useRef(null);
  
  const dispatch = useDispatch();
  const { news } = useSelector((state) => state.news);

  useEffect(() => {
    dispatch(getNews());
  }, [dispatch]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (megamenuRef.current && !megamenuRef.current.contains(event.target)) {
        setIsMegamenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const uniqueCategories = [...new Set(news.map(item => item.category))];

  return (
    <header className="bg-white border-b border-gray-200 shadow-sm sticky top-0 z-30">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-3">
            <img src={Logo} alt="Logo Literasiologi Indonesia" className="w-12 h-12" />
            <div className="hidden sm:block">
              <h1 className="text-lg font-bold text-gray-900">{websiteShortName}</h1>
              <p className="text-xs text-gray-500">penerbit-literasiologi.org</p>
            </div>
          </Link>
          
          <nav className="hidden md:flex items-center gap-6">
            <Link to="/" className="text-gray-600 hover:text-dark-blue-700 transition-colors font-medium">Beranda</Link>
            <Link to="/books" className="text-gray-600 hover:text-dark-blue-700 transition-colors font-medium">Buku</Link>
            <Link to="/tentang-kami" className="text-gray-600 hover:text-dark-blue-700 transition-colors font-medium">Tentang Kami</Link>
            <Link to="/faq" className="text-gray-600 hover:text-dark-blue-700 transition-colors font-medium">FAQ</Link>
            <Link to="/information" className="text-gray-600 hover:text-dark-blue-700 transition-colors font-medium">Informasi</Link>
            <Link to="/hubungi-kami" className="text-gray-600 hover:text-dark-blue-700 transition-colors font-medium">Hubungi Kami</Link>
            <div className="relative" ref={megamenuRef}>
              <button 
                onClick={() => setIsMegamenuOpen(!isMegamenuOpen)}
                className="flex items-center gap-1 text-gray-600 hover:text-dark-blue-700 transition-colors font-medium"
              >
                Berita
                <svg 
                  className={`w-4 h-4 transition-transform ${isMegamenuOpen ? 'rotate-180' : ''}`} 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              {isMegamenuOpen && (
                <div className="absolute left-1/2 -translate-x-1/2 mt-2 w-96 bg-white rounded-2xl border border-gray-200 shadow-xl p-6">
                  <h3 className="text-lg font-semibold text-gray-900 mb-4">Kategori Berita</h3>
                  <div className="grid grid-cols-2 gap-3">
                    {uniqueCategories.length > 0 ? (
                      uniqueCategories.map(category => (
                        <Link
                          key={category}
                          to={`/news/${category.toLowerCase().replace(/\s+/g, '-')}`}
                          onClick={() => setIsMegamenuOpen(false)}
                          className="flex items-center gap-2 px-4 py-3 bg-gray-50 hover:bg-dark-blue-50 text-gray-700 hover:text-dark-blue-700 rounded-xl transition-colors"
                        >
                          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                          </svg>
                          {category.charAt(0).toUpperCase() + category.slice(1)}
                        </Link>
                      ))
                    ) : (
                      <>
                        <Link 
                          to="/news/pengabdian" 
                          onClick={() => setIsMegamenuOpen(false)}
                          className="flex items-center gap-2 px-4 py-3 bg-gray-50 hover:bg-dark-blue-50 text-gray-700 hover:text-dark-blue-700 rounded-xl transition-colors"
                        >
                          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                          </svg>
                          Pengabdian
                        </Link>
                        <Link 
                          to="/news/pengembangan" 
                          onClick={() => setIsMegamenuOpen(false)}
                          className="flex items-center gap-2 px-4 py-3 bg-gray-50 hover:bg-dark-blue-50 text-gray-700 hover:text-dark-blue-700 rounded-xl transition-colors"
                        >
                          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                          </svg>
                          Pengembangan Dosen
                        </Link>
                      </>
                    )}
                  </div>
                </div>
              )}
            </div>
          </nav>
          
          <Link to="/login" className="inline-flex items-center gap-2 px-4 py-2 bg-dark-blue-700 text-white rounded-xl hover:bg-dark-blue-800 transition-colors font-medium text-sm">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />
            </svg>
            Admin
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Header;
